import React from "react";
import ABOUT_DATA from "../../utils/aboutData";

export default function RightContainer() {
  // Sections to render dynamically
  const sections = [
    {
      heading: ABOUT_DATA.top_companies_heading,
      data: ABOUT_DATA.top_companies.data,
    },
    {
      heading: ABOUT_DATA.send_money_heading,
      data: ABOUT_DATA.send_money.data,
    },
    {
      heading: ABOUT_DATA.transfer_routes_heading,
      data: ABOUT_DATA.transfer_routes.data,
    },
  ];

  return (
    <div className="flex flex-col gap-[110px]">
      {sections.map(({ heading, data }, index) => (
        <div
          key={index}
          className="bg-[#EBEBEB] py-[25px] px-[30px] flex flex-col gap-[10px]"
        >
          <h2 className="text-[#111B31] font-bold">{heading}</h2>
          <hr className="h-[3px] bg-gray-500" />
          <ul className="flex flex-col gap-[10px]">
            {data.map((item, i) => (
              <li key={i} className="text-[#7F8190] font-[500]">
                {item}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
